export default function getInsertionSortAnnimatio(array) {
  const annimations = [];

  for (let j = 1; j < array.length; j++) {
    let key = array[j];
    let i = j - 1;
    while (i >= 0 && array[i] > key) {
      annimations.push([i, i + 1, array[i], array[i + 1]]);
      array[i + 1] = array[i];
      array[i] = key;
      i = i - 1;
    }
  }
  return annimations;
}
